<div class="controls-container">
        <div class="controls-header">Slider</div>
    
        <div class="controls-sub-header">Slider Default</div>
    
        <pm-slider></pm-slider>

        <div class="controls-sub-header">Slider Disabled</div>
    
        <pm-slider></pm-slider>

        <div class="controls-sub-header">Slider Theme 1</div>
    
        <pm-slider></pm-slider>

        <div class="controls-sub-header">Slider Theme 2</div>
    
        <pm-slider></pm-slider>
    </div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/slider/slider.html